if (!customElements.get('all-destinations-menu')) {
  customElements.define(
    'all-destinations-menu',
    class extends HTMLElement {
      constructor() {
        super();

        this.allDestinationsButton = this.querySelector('#sidebar__all-destinations-link');
        this.inner = this.querySelector('.mobile-sidebar__inner');
        this.allDestinationsMenu = this.querySelector('.all-destinations__container.in-sidebar');
        this.backBtn = this.querySelector('.destinations__back-btn');
      }

      showAllDestinations() {
        if (!this.allDestinationsMenu || !this.inner) return;

        this.allDestinationsMenu.classList.add('active');
        this.inner.classList.add('hidden');
      }

      hideAllDestinations() {
        if (!this.allDestinationsMenu || !this.inner) return;

        this.allDestinationsMenu.classList.remove('active');
        this.inner.classList.remove('hidden');
      }

      connectedCallback() {
        const init = () => {
          this.inSidebar = this.closest('.mobile-sidebar') !== null;

          if (this.allDestinationsButton) {
            this.allDestinationsButton.addEventListener(
              'click',
              this.showAllDestinations.bind(this),
            );
          }

          if (this.backBtn) {
            this.backBtn.addEventListener('click', this.hideAllDestinations.bind(this));
          }
        };

        this.initCallback = init;
        document.readyState === 'loading'
          ? document.addEventListener('DOMContentLoaded', this.initCallback)
          : init();
      }

      disconnectedCallback() {
        this.allDestinationsButton?.removeEventListener(
          'click',
          this.showAllDestinations.bind(this),
        );
        this.backBtn?.removeEventListener('click', this.hideAllDestinations.bind(this));

        if (this.initCallback) {
          document.removeEventListener('DOMContentLoaded', this.initCallback);
        }
      }
    },
  );
}
